import React, { useEffect, useRef, useState } from "react";
import Header from "../common/Header";
import $ from "jquery";
import { dateFormat } from "../helpers/date";
import triangle from "../../images/triangle.svg";
import AddOrderModal from "../../modal/AddOrderModal";
import ConfirmModal from "../../modal/ConfirmModal";
import { Link, useNavigate } from "react-router-dom";
import Select from "react-select";
import useAuth from "../../hooks/useAuth";
import CratesModal from "../../modal/CratesModal";
import { convertDataToWarehouseSheet } from "../helpers/print";
import RecentSalesModal from "../../modal/RecentSalesModal";
import moment from "moment";
import Toastify from "../common/Toastify";
import { GETREQUEST, POSTREQUEST } from "../helpers/ServiceRequest";
import { addTrailingZeros, formatPrice } from "../helpers/common";
import { generateInvoicePdf } from "../Pdfs/invoice";
import { generatePriceListPdf } from "../Pdfs/PriceSheet";
import EmailModal from "../../modal/EmailModal";

function FinaliseOrder() {
  const navigate = useNavigate();
  const [addOrderModal, setAddOrderModal] = useState(false);
  const [previewModal, setPreviewModal] = useState(false);
  const [cratesModal, setCratesModal] = useState(false);
  const [recentSalesModal, setRecentSalesModal] = useState(false);
  const [customerId, setCustomerId] = useState("all")
  const [customerValue, setCustomerValue] = useState(null);
  const [customersCode, setCustomersCode] = useState([]);
  const [orderDate, setOrderDate] = useState(dateFormat(new Date()));
  const [orderDetails, setOrderDetails] = useState([]);
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');
  const [crates, setCrates] = useState([]);
  const [defaultCrate, setDefaultCrate] = useState(null);
  const [units, setUnits] = useState([]);
  const [agents, setAgents] = useState([]);
  const [recentSalesArray, setRecentSalesArray] = useState([]);
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [invoiceNo, setInvoiceNo] = useState(null);
  const { user } = useAuth();
  const inputTypesRef = useRef([]);

  useEffect(() => {
    var headerHeight = $("header").outerHeight();
    var mainHeight = $(window).height() - headerHeight;
    $("main").height(mainHeight);
    $("main").css("margin-top", headerHeight + "px");

    var tableRow = ".table-form tbody > tr";

    $(tableRow).on("focusin", function () {
      $(this).addClass("focus-tr");
    });

    $(tableRow).on("focusout", function () {
      $(this).removeClass("focus-tr");
    });
  });

  useEffect(() => {
    const fetchData = async () => {
      let commanURL = process.env.REACT_APP_API_URL + "/get-comman-all-for-product";
      let response = await GETREQUEST(commanURL, user.jwtToken);
      if (response?.data) {
        let containersList = [];
        response.data.containers.forEach((item) => {
          containersList = [...containersList, { label: item.TypeInCode, value: item.ContainerID, ...item }];
        });

        containersList.sort((a, b) => {
          const numA = parseInt(a.label);
          const numB = parseInt(b.label);

          if (!isNaN(numA) && !isNaN(numB)) {
            return numA - numB;
          } else if (!isNaN(numA)) {
            return -1;
          } else if (!isNaN(numB)) {
            return 1;
          } else {
            return a.TypeInCode.localeCompare(b.TypeInCode);
          }
        });

        setCrates(containersList);
        let crateId = containersList.find((item) => item.label == "Un");
        setDefaultCrate(crateId);

        let unitList = [];
        response.data.units.forEach((item) => {
          unitList = [...unitList, { label: item.UnitName, value: item.UnitID }];
        });
        setUnits(unitList);

        let agentList = [];
        response.data.agent.forEach((item) => {
          agentList = [...agentList, { label: item.AgentCode, value: item.AgentID, ...item }];
        });
        setAgents(agentList);
      }
    }

    fetchData();
  }, []);

  useEffect(() => {
    getOrderDetails()
  }, [customerId]);

  useEffect(() => {
    updateOrderDate();
  }, [orderDate]);

  const updateOrderDate = () => {
    setCustomerId("all");
    setCustomerValue(null);
    setCustomersCode([]);
    setOrderDetails([]);

    fetchCustomers();
  }

  const CustomOptionAgent = (props) => {
    return (

      <div
        className=""
        style={{
          background: props.isFocused
            ? '#01B1E3'
            : props.isSelected
              ? 'rgb(54, 179, 126)'
              : "#fff", color: "gray", zIndex: 1, padding: " 8px 12px", cursor: "default", display: "block", fontSize: "inherit", width: "100%"
        }}
        {...props.innerProps}
        ref={props.innerRef}
      >
        {props.label}
      </div>
    )
  }

  const getOrderDetails = async () => {
    if (customerId && orderDate && customerId !== 'all') {
      let warehouseSheetURL =
        process.env.REACT_APP_API_URL + `/print-warehouse-sheet`;
      let payload = {
        "customerId": customerId,
        "fromDate": orderDate,
        "vpCodes": "all",
        "InvoiceDate": moment(orderDate).subtract(30, 'd').format('YYYY-MM-DD'),
      }

      let response = await POSTREQUEST(warehouseSheetURL, payload, user.jwtToken);
      if (response?.data) {
        let updatedData = response.data && response.data.length > 0 && response.data.map((item) => {
          let { extSell, extBuy, extRRP, RetailPC } = updateTtlProd(item.Qty, item.Count, item.SellPrice, item.BuyPrice, item.RRP, item.IgnoreCrate);
          return {
            ...item,
            ContainerID: item.ContainerID ? crates.length > 0 && crates.find(crate => crate.ContainerID == item.ContainerID)?.ContainerID : defaultCrate?.ContainerID,
            ContainerName: item.ContainerID ? crates.length > 0 && crates.find(crate => crate.ContainerID == item.ContainerID)?.TypeInCode : defaultCrate?.TypeInCode,
            Profit: updateProfit(item.BuyPrice, item.SellPrice),
            SellPrice: addTrailingZeros(item.SellPrice),
            BuyPrice: addTrailingZeros(item.BuyPrice),
            Qty: addTrailingZeros(item.Qty),
            ExtSell: extSell,
            ExtBuy: extBuy,
            ExtRRP: extRRP,
            RetailPC: RetailPC
          }
        })

        let agentOHProducts = [];
        let filterProducts = updatedData.filter((product) => {
          let AgentCode = product?.tblAgent?.AgentCode;
          if (AgentCode != "OH") {
            return product
          }
          else {
            agentOHProducts.push(product)
          }
        })

        filterProducts?.sort((a, b) => a.ProductName.localeCompare(b.ProductName)).sort((a, b) =>
          a.tblAgent.AgentCode.localeCompare(b.tblAgent.AgentCode)
        );

        agentOHProducts?.sort((a, b) => a.ProductName.localeCompare(b.ProductName));
        updatedData = [...filterProducts, ...agentOHProducts];
        setOrderDetails(updatedData)
      }
    }
  }

  const updateProfit = (buyPrice, sellPrice) => {
    if (buyPrice >= 0 && sellPrice >= 0) {
      buyPrice = parseFloat(buyPrice);
      sellPrice = parseFloat(sellPrice);
      let profit = 100 - (buyPrice / sellPrice * 100)
      profit = isFinite(profit) ? parseFloat(profit).toFixed(2) : 0;
      return profit;
    }
    else {
      return 0;
    }
  }

  const updateTtlProd = (qty, count, sellPrice, buyPrice, RRP, isIgnoreCrate = false) => {
    let extSell = 0;
    let extBuy = 0;
    let extRRP = 0;
    let RetailPC = 0;
    if (sellPrice >= 0 && buyPrice >= 0) {
      count = count && count > 0 ? count : 1;
      let value = isIgnoreCrate ? count : qty * count;
      extSell = value * sellPrice;
      extBuy = value * buyPrice;
      extRRP = value * RRP;
      extSell = extSell ? extSell.toFixed(2) : 0;
      RetailPC = 0;

      if (sellPrice > 0 && RRP > 0) {
        RetailPC = 100 - (sellPrice / RRP * 100)
        RetailPC = isFinite(RetailPC) ? RetailPC.toFixed(2) : 0
      }

    } return { extSell, extBuy, extRRP, RetailPC };
  }

  const fetchCustomers = async () => {
    let URL =
      process.env.REACT_APP_API_URL + `/search-customer?orderDate=${orderDate}`;
    let response = await GETREQUEST(URL, user.jwtToken);
    if (response?.data) {
      let cnList = [];
      let ccList = [];
      response.data.forEach((item) => {
        if (item.tblOrders[0]?.OrderId != null) {
          cnList = [...cnList, { label: item.CustomerName, value: item.CustomerID, ...item }];
          ccList = [...ccList, { label: item.CustomerCode, value: item.CustomerID, ...item }];
        }
      });
      ccList.sort((a, b) => a.label.localeCompare(b.label));
      setCustomersCode(ccList);
    }
  }

  function handleCustomerChanged(e) {
    // reset Previous state
    setOrderDetails([]);
    setCustomerValue(null)
    setCustomerId(e.value);
    setCustomerValue(e);
  }

  const PreviewHandler = () => {
    saveBulkOrder(true);
  }

  const handleInputChange = (index, key, value) => {
    setOrderDetails(prevOrderDetails => {
      const updatedOrderDetails = [...prevOrderDetails];
      updatedOrderDetails[index][key] = value;
      return updatedOrderDetails;
    });
  }

  const handleCrateChange = (e, index) => {
    setOrderDetails(prevOrderDetails => {
      const updatedOrderDetails = [...prevOrderDetails];
      updatedOrderDetails[index]['ContainerID'] = e.value;
      updatedOrderDetails[index]['ContainerName'] = crates.find(crate => crate.ContainerID == e.value).TypeInCode || '';
      return updatedOrderDetails
    })
  }

  const calculateProfit = (index, buyPrice, sellPrice) => {
    buyPrice = addTrailingZeros(buyPrice);
    sellPrice = addTrailingZeros(sellPrice);
    if (buyPrice >= 0 && sellPrice >= 0) {
      buyPrice = parseFloat(buyPrice);
      sellPrice = parseFloat(sellPrice);
      let profit = 100 - (buyPrice / sellPrice * 100)
      profit = isFinite(profit) ? parseFloat(profit).toFixed(2) : 0;
      setOrderDetails(prevOrderDetails => {
        const updatedOrderDetails = [...prevOrderDetails];
        updatedOrderDetails[index]['Profit'] = profit;
        return updatedOrderDetails;
      });
    }
  }

  const calculateProfitPercentage = () => {
    if (orderDetails && orderDetails.length > 0) {
      let totalSalesPrice = 0;
      let totalBuyPrice = 0;
      orderDetails.map((item) => {
        totalSalesPrice += item.ExtSell ? parseFloat(item.ExtSell) : 0
        totalBuyPrice += item.ExtBuy ? parseFloat(item.ExtBuy) : 0
      })
      const totalProfit = totalSalesPrice - totalBuyPrice;
      let result = 0;
      if (totalProfit && totalSalesPrice)
        result = totalProfit / totalSalesPrice
      return isNaN(result) ? 0 : (result * 100).toFixed(2)
      const profitPercentage = (totalProfit / totalSalesPrice) * 100;
      return isNaN(profitPercentage) ? 0 : profitPercentage.toFixed(2) + '%';
    }
    else
      return 0;
  }

  const calculateRRPPercentage = () => {
    if (orderDetails && orderDetails.length > 0) {
      let totalExtRRP = 0;
      let totalSalesPrice = 0;
      orderDetails.map((item) => {
        totalSalesPrice += item.ExtSell ? parseFloat(item.ExtSell) : 0
        totalExtRRP += item.ExtRRP ? parseFloat(item.ExtRRP) : 0
      })
      let result = 0;
      if (totalSalesPrice && totalExtRRP)
        result = 100 - (totalSalesPrice * 100 / totalExtRRP)
      return isNaN(result) ? 0 : (result * 100).toFixed(2)
    }
    else
      return 0;
  }

  const calculateTtlProd = (index, qty, count, sellPrice, buyPrice, RRP, isIgnoreCrate = false) => {
    buyPrice = addTrailingZeros(buyPrice);
    sellPrice = addTrailingZeros(sellPrice);
    if (sellPrice >= 0 && buyPrice >= 0) {
      buyPrice = parseFloat(buyPrice);
      sellPrice = parseFloat(sellPrice);
      count = count && count > 0 ? count : 1;
      let value = isIgnoreCrate ? count : qty * count;
      let extSell = value * sellPrice;
      let extBuy = value * buyPrice;
      let extRRP = value * RRP;
      setOrderDetails(prevOrderDetails => {
        const updatedOrderDetails = [...prevOrderDetails];
        updatedOrderDetails[index]['ExtSell'] = extSell ? extSell.toFixed(2) : 0;
        updatedOrderDetails[index]['ExtBuy'] = extBuy ? extBuy.toFixed(2) : 0;
        updatedOrderDetails[index]['ExtRRP'] = extRRP ? extRRP.toFixed(2) : 0;
        return updatedOrderDetails;
      });
      let RetailPC = 0;
      if (sellPrice > 0 && RRP > 0) {
        RetailPC = 100 - (sellPrice / RRP * 100)
      }
      setOrderDetails(prevOrderDetails => {
        const updatedOrderDetails = [...prevOrderDetails];
        updatedOrderDetails[index]['RetailPC'] = RetailPC ? RetailPC.toFixed(2) : 0;
        return updatedOrderDetails;
      });
    }
  }

  const calculateTotalTtlProd = () => {
    if (orderDetails && orderDetails.length > 0) {
      let total = 0;
      orderDetails.map((item) => {
        if (item.ExtSell)
          total += parseFloat(item.ExtSell)
      })
      return total.toFixed(2);
    }
    else
      return 0;
  }

  const saveBulkOrder = async (isFinalise = false) => {
    let updateOrderURL = process.env.REACT_APP_API_URL + `/order-finalise`;
    let bulkOrderDetail = [];
    let isCash = false;
    const groupedOrders = {};

    if (isFinalise) {
      isCash = customerValue?.CustomerName?.startsWith("C/-") ?? isCash;
    }

    orderDetails.forEach((OrderItem) => {
      const orderId = OrderItem.OrderID;

      if (!groupedOrders[orderId]) {
        groupedOrders[orderId] = {
          OrderID: OrderItem.OrderID,
          OrderDate: OrderItem.tblOrder.OrderDate,
          PurchaseOrder: OrderItem.tblOrder.PurchaseOrder,
          DeliveryInstructions: OrderItem.tblOrder.DeliveryInstructions,
          OrderNotes: OrderItem.tblOrder.OrderNotes,
          CustomerID: OrderItem.tblOrder.CustomerID,
          AgentId: OrderItem.tblAgent.AgentID,
          OrderStatus: isFinalise ? 'I' : OrderItem.tblOrder.OrderStatus,
          isFinalise: isFinalise,
          isCash,
          InvoiceDate: isFinalise ? new Date() : OrderItem.tblOrder.InvoiceDate,
          OrderDetails: []
        };
      }

      groupedOrders[orderId].OrderDetails.push({
        OrderID: OrderItem.OrderID,
        ODID: OrderItem.ODID,
        ProductID: OrderItem.ProductID,
        ProductCode: OrderItem.ProductCode,
        ProductGST: OrderItem.ProductCode == "*" ? 0 : OrderItem.ProductCode == "**" ? 1 : OrderItem.tblProduct?.GST,
        UnitID: OrderItem.UnitID,
        ClassName: OrderItem.ClassName,
        SizeName: OrderItem.SizeName,
        BuyPrice: parseFloat(OrderItem.BuyPrice || 0),
        SellPrice: parseFloat(OrderItem.SellPrice || 0),
        LastSellPU: parseFloat(OrderItem.LastSellPU || 0),
        Profit: parseFloat(OrderItem.Profit || 0),
        Count: OrderItem.Count,
        BPException: OrderItem.BPException != null ? OrderItem.BPException : 0,
        CntException: OrderItem.CntException != null ? OrderItem.CntException : 0,
        AgentID: OrderItem.tblAgent.AgentID,
        ProductName: OrderItem.ProductName,
        Qty: OrderItem.Qty,
        ExtBuy: parseFloat(OrderItem.ExtBuy || 0),
        ExtSell: parseFloat(OrderItem.ExtSell || 0),
        IgnoreCrate: OrderItem.IgnoreCrate,
        ContainerID: OrderItem.ContainerID,
        ContainerValue: crates.find(crate => crate.ContainerID == OrderItem.ContainerID)?.ContainerValue,
        ReturnValue: crates.find(crate => crate.ContainerID == OrderItem.ContainerID)?.ReturnValue,
        RRP: parseFloat(OrderItem.RRP || 0),
        ExtRRP: parseFloat(OrderItem.ExtRRP || 0),
        RetailPC: parseFloat(OrderItem.RetailPC || 0),
      });

    });

    bulkOrderDetail = Object.values(groupedOrders);
    setMessage('');
    setMessageType('');
    let response = await POSTREQUEST(updateOrderURL, bulkOrderDetail, user.jwtToken);
    if (response?.data) {
      if (response.data.success) {
        setMessage(response.data.message)
        setMessageType('success')
        if (response.data.InvoiceNo && isFinalise) {
          setInvoiceNo(response.data.InvoiceNo);
          setShowEmailModal(true);
          setTimeout(() => {
            getInvoice(response.data.InvoiceNo)
          }, 2000);
        }

      } else {
        setMessage(response.data.message)
        setMessageType("error")
      }
    }
    else {
      setMessage(response?.error?.message)
      setMessageType("error")
    }
  }

  const getInvoice = async (id) => {
    if (id) {
      const InvoiceURL = `${process.env.REACT_APP_API_URL}/get-invoice/${id}`;
      let response = await GETREQUEST(InvoiceURL, user.jwtToken);
      if (response?.data) {
        await generateInvoicePdf(response.data);
      } else {
        setMessageType('text-danger');
        setMessage(response?.error?.message)
      }
    }
  }
  const handlePriceList = async () => {
    let printPriceListData = convertDataToWarehouseSheet(orderDetails, '', 0);
    await generatePriceListPdf(printPriceListData);
  }

  const handleRecentSales = (index) => {
    if (orderDetails[index]?.RecentSales) {
      setRecentSalesModal(true);
      setRecentSalesArray(orderDetails[index]?.RecentSales);
    }
  }

  const handleKeyEvent = (e) => {
    const keyCode = e.keyCode;
    const targetType = e.target?.id;
    const isSelectType = targetType.includes("react-select");
    let currentIndex = e.currentTarget.id
    let firstCurrentIndex = parseInt(currentIndex.slice(0, currentIndex.length - 1));
    let lastCurrentIndex = parseInt(currentIndex.slice(currentIndex.length - 1));
    if (keyCode === 35) {
      inputTypesRef[`${firstCurrentIndex}${7}`]?.focus();
    } else if (keyCode === 36) {
      inputTypesRef[`${firstCurrentIndex}${0}`]?.focus();
    }
    else if (keyCode === 39 || keyCode === 13) {
      inputTypesRef[`${firstCurrentIndex}${lastCurrentIndex + 1}`]?.focus();
    } else if (keyCode === 37) {
      inputTypesRef[`${firstCurrentIndex}${lastCurrentIndex - 1}`]?.focus();
    } else if (keyCode === 40 && !isSelectType) {
      inputTypesRef[`${firstCurrentIndex + 1}${lastCurrentIndex}`]?.focus();
    }
    else if (keyCode === 38 && !isSelectType) {
      inputTypesRef[`${firstCurrentIndex - 1}${lastCurrentIndex}`]?.focus();
    }
  };

  const handleSendEmail = async (to, subject, body) => {
    setMessageType('')
    setMessage('')
    let emailURL = `${process.env.REACT_APP_API_URL}/email-pdf`;
    const payload = {
      to,
      subject,
      emailBody: body,
      id: invoiceNo,
      type: 'invoice',
      date: orderDate
    }
    let response = await POSTREQUEST(emailURL, payload, user.jwtToken);
    if (response?.data) {
      if (response?.data.success) {
        setMessage(response?.data.message);
        setMessageType('success');
      } else {
        setMessage(response?.data.message);
        setMessageType('error');
      }
    }
    else {
      setMessage(response?.data?.message || response?.data?.error?.message || 'Failed to send Email !!');
      setMessageType('error');
    }
  }

  const handleModal = () => {
    updateOrderDate();
    setShowEmailModal(false);
  }

  const updateOrderDetails = (newOrders) => {
    newOrders = newOrders.map((item) => {
      let { extSell, extBuy, extRRP, RetailPC } = updateTtlProd(item.Qty, item.Count, item.SellPrice, item.BuyPrice, item.RRP, item.IgnoreCrate);
      return {
        ...item,
        ContainerID: item.ContainerID ? crates.length > 0 && crates.find(crate => crate.ContainerID == item.ContainerID)?.ContainerID : defaultCrate?.ContainerID,
        ContainerName: item.ContainerID ? crates.length > 0 && crates.find(crate => crate.ContainerID == item.ContainerID)?.TypeInCode : defaultCrate?.TypeInCode,
        Profit: updateProfit(item.BuyPrice, item.SellPrice),
        LastSellPU: addTrailingZeros(item.LastSellPU),
        SellPrice: addTrailingZeros(item.SellPrice),
        BuyPrice: addTrailingZeros(item.BuyPrice),
        Qty: addTrailingZeros(item.Qty),
        ExtSell: extSell,
        ExtBuy: extBuy,
        ExtRRP: extRRP,
        RetailPC: RetailPC,
        tblAgent: agents?.find(agent => agent.value == item.AgentID)
      }
    });


    let agentOHProducts = [];

    let allOrders = [...orderDetails, ...newOrders];

    let filterAllProducts = allOrders.filter((product) => {
      let AgentCode = product?.tblAgent?.AgentCode;
      if (AgentCode != "OH") {
        return product
      }
      else {
        agentOHProducts.push(product)
      }
    })

    filterAllProducts?.sort((a, b) => a.ProductName.localeCompare(b.ProductName)).sort((a, b) =>
      a.tblAgent.AgentCode.localeCompare(b.tblAgent.AgentCode)
    );

    agentOHProducts?.sort((a, b) => a.ProductName.localeCompare(b.ProductName));
    const updatedData = [...filterAllProducts, ...agentOHProducts];

    setOrderDetails(updatedData);
  }

  return (
    <React.Fragment>
      {addOrderModal && (
        <AddOrderModal modal={addOrderModal} updateOrderDetails={updateOrderDetails} user={user} customerId={customerId} crates={crates} units={units} OrderID={orderDetails.length > 0 ? orderDetails[0].OrderID : null} customerCategory={customerValue?.Category} setModal={setAddOrderModal} />
      )}

      {cratesModal && (
        <CratesModal modal={cratesModal} orderDetails={orderDetails} crates={crates} setModal={setCratesModal} />
      )}

      {previewModal && (
        <ConfirmModal modal={previewModal} modalHeader="Finalise Order ?" modalBody="You are about to finalise Order. Are you sure ?" setModal={setPreviewModal} onConfirm={PreviewHandler} />
      )}

      {recentSalesModal && (
        <RecentSalesModal modal={recentSalesModal} data={recentSalesArray} setModal={() => { setRecentSalesModal(false); setRecentSalesArray([]) }} />
      )}

      {showEmailModal && (
        <EmailModal modal={showEmailModal} setModal={handleModal} code={"invoice"} handleSendEmail={handleSendEmail} emailUser={customerValue?.EmailAddresses} userName={customerValue?.CustomerCode} date={orderDate} />
      )}

      <Header />
      {message && <Toastify message={message} type={messageType} />}
      <main className="bg-lite-grey overflow-auto">
        <section className="px-4 pt-3 pb-4 overflow-hidden table-listing">
          <div className="table-elements">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item fs-15">
                  <Link
                    to="/all-orders"
                    className="text-decoration-none text-primary"
                  >
                    Orders
                  </Link>
                </li>
                <li
                  className="breadcrumb-item fs-15 active"
                  aria-current="page"
                >
                  Finalise Order
                </li>
              </ol>
            </nav>
          </div>

          <div className="card border-bottom-0">
            <div className="card-header bg-white d-flex align-items-center justify-content-between cpx-20 cpy-14 sticky-top flex-nowrap">
              <h1 className="title-semibold fs-24 mb-xl-0 mb-0 d-flex align-items-center text-nowrap me-5 me-xl-0">
                Finalise Order
              </h1>
              <div className="filter-elements d-flex align-items-center">
                <div className="custom-group flex-nowrap mb-xl-0">
                  <label
                    htmlFor=""
                    className="pe-2 d-flex align-items-center fs-14 text-lite"
                  >
                    Ship date:
                  </label>
                  <div
                    className="position-relative cme-15"
                    data-provide="datepicker"
                  >
                    <input
                      type="date"
                      id="datepicker"
                      className="form-control input-sm date input-datepicker"
                      placeholder="Select Date"
                      defaultValue={orderDate}
                      onChange={(e) => {
                        setOrderDate(e.target.value);

                      }}
                    />
                  </div>
                </div>
                <div className="custom-group flex-nowrap mb-lg-0">
                  <label
                    htmlFor=""
                    className="pe-2 d-flex align-items-center fs-14 text-lite"
                  >
                    Customer:
                  </label>

                  <Select
                    className="input-sm input-width-125"
                    defaultValue={"Select Customers"}
                    value={customerValue}
                    options={customersCode}
                    placeholder="Select Customer"
                    onChange={handleCustomerChanged}
                    components={{ Option: CustomOptionAgent }}
                  ></Select>


                </div>
              </div>
              <div></div>
            </div>
            <div className="card-body p-4 border-bottom">
              <div className="card-table table-responsive">
                <table className="table table-form">
                  <thead>
                    <tr>
                      <td scope="col" className="width-lg-1"></td>
                      <td scope="col" className="width-lg-6">
                        Agent
                      </td>
                      <td scope="col" className="width-lg-16">Product Name</td>
                      <td scope="col" className="width-lg-4">
                        Qty
                      </td>
                      <td scope="col" className="width-lg-6">
                        Crate
                      </td>
                      <td scope="col" className="width-lg-6">
                        Count
                      </td>
                      <td scope="col" className="width-lg-1 px-4">
                        t
                      </td>
                      <td scope="col" className="width-lg-1 px-4"></td>
                      <td scope="col" className="width-lg-6">
                        Sell Price
                      </td>
                      <td scope="col" className="width-lg-6">
                        Buy Price
                      </td>
                      <td scope="col" className="width-lg-6 text-center">
                        % Profit
                      </td>
                      <td scope="col" className="width-lg-6 text-center">
                        Tlt Prod
                      </td>
                      <td scope="col" className="width-lg-6">
                        RRP/Kg
                      </td>
                      <td scope="col" className="width-lg-6">
                        Ret.Gp
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    {orderDetails.length > 0 && orderDetails.map((orderDetailItem, index) => {
                      let ProductName = `${orderDetailItem.ProductName} ${orderDetailItem.ClassName || ''} ${orderDetailItem.SizeName || ''} ${orderDetailItem?.tblUnit?.UnitName || ''}`
                      ProductName = ProductName?.replace(/\s+/g, ' ').trim();
                      return (<tr key={index + 1} className="custom-space">
                        <td valign="middle">
                          <img src={triangle} className="indicator" alt="" />
                        </td>
                        <td>
                          <input
                            type="text"
                            className="form-control input-sm input-width-100"
                            placeholder="Agent"
                            value={orderDetailItem?.tblAgent?.AgentCode}
                            disabled
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            className="form-control input-sm input-width-359"
                            placeholder="Product Name"
                            value={ProductName}
                            disabled
                          />
                        </td>
                        <td>
                          <input
                            id={`${index}0`}
                            type="text"
                            className="form-control input-sm text-end input-width-90"
                            placeholder="Qty"
                            value={orderDetailItem.Qty}
                            onChange={(e) => handleInputChange(index, 'Qty', formatPrice(e.target.value))}
                            onBlur={(e) => handleInputChange(index, 'Qty', addTrailingZeros(e.target.value))}
                            ref={el => inputTypesRef[`${index}0`] = el}
                            onKeyDown={handleKeyEvent}
                          />
                        </td>
                        <td>
                          <Select
                            id={`${index}1`}
                            className="input-sm input-width-90"
                            defaultValue={"Select Crate"}
                            value={crates.find(crate => crate.ContainerID == orderDetailItem.ContainerID) || ''}
                            options={crates}
                            placeholder="Select Crate"
                            onChange={(e) => handleCrateChange(e, index)}
                            components={{ Option: CustomOptionAgent }}
                            ref={el => inputTypesRef[`${index}1`] = el}
                            onKeyDown={handleKeyEvent}
                          ></Select>

                        </td>
                        <td>
                          <input
                            id={`${index}2`}
                            type="text"
                            className="form-control input-sm input-width-90 text-end"
                            placeholder="0"
                            value={orderDetailItem.Count}
                            onChange={(e) => {
                              setOrderDetails(prevOrderDetails => {
                                const updatedOrderDetails = [...prevOrderDetails];
                                updatedOrderDetails[index]['Count'] = e.target.value;
                                return updatedOrderDetails
                              })
                            }}
                            onBlur={(e) => {
                              calculateTtlProd(index, orderDetailItem.Qty, e.target.value, orderDetailItem.SellPrice, orderDetailItem.BuyPrice, orderDetailItem.RRP, orderDetailItem.IgnoreCrate)
                            }}
                            ref={el => inputTypesRef[`${index}2`] = el}
                            onKeyDown={handleKeyEvent}
                          />
                        </td>
                        <td valign="middle">
                          <input
                            id={`${index}3`}
                            type="checkbox"
                            className="form-check-input d-flex mx-auto"
                            checked={orderDetailItem.IgnoreCrate}
                            onChange={(e) => {
                              setOrderDetails(prevOrderDetails => {
                                const updatedOrderDetails = [...prevOrderDetails];
                                updatedOrderDetails[index]['IgnoreCrate'] = e.target.checked ? 1 : 0;
                                return updatedOrderDetails
                              });
                              calculateTtlProd(index, orderDetailItem.Qty, orderDetailItem.Count, orderDetailItem.SellPrice, orderDetailItem.BuyPrice, orderDetailItem.RRP, e.target.checked)
                            }}
                            ref={el => inputTypesRef[`${index}3`] = el}
                            onKeyDown={handleKeyEvent}
                          />
                        </td>
                        <td valign="middle" align="center">
                          <span style={{ cursor: "pointer" }} className="border border-1 border-secondary cpx-5 text-secondary cpy-2 fs-14 text-center rounded-1" onClick={() => handleRecentSales(index)}>
                            R
                          </span>
                        </td>
                        <td>
                          <div className="position-relative input-icon">
                            <input
                              id={`${index}4`}
                              type="text"
                              className="form-control input-sm text-end ps-4 input-width-80"
                              placeholder="0.00"
                              onChange={(e) => handleInputChange(index, 'SellPrice', formatPrice(e.target.value))}
                              onBlur={(e) => {
                                handleInputChange(index, 'SellPrice', addTrailingZeros(e.target.value))
                                calculateProfit(index, orderDetailItem.BuyPrice, e.target.value);
                                calculateTtlProd(index, orderDetailItem.Qty, orderDetailItem.Count, e.target.value, orderDetailItem.BuyPrice, orderDetailItem.RRP, orderDetailItem.IgnoreCrate)
                              }}
                              value={orderDetailItem.SellPrice || ''}
                              ref={el => inputTypesRef[`${index}4`] = el}
                              onKeyDown={handleKeyEvent}
                            />
                            <span className="text-lite cps-10 fs-14">$</span>
                          </div>
                        </td>

                        <td>
                          <div className="position-relative input-icon">
                            <input
                              id={`${index}5`}
                              type="text"
                              placeholder="0.00"
                              className="form-control input-sm text-end ps-4 input-width-80"
                              onChange={(e) => handleInputChange(index, 'BuyPrice', formatPrice(e.target.value))}
                              onBlur={(e) => {
                                handleInputChange(index, 'BuyPrice', addTrailingZeros(e.target.value))
                                calculateProfit(index, e.target.value, orderDetailItem.SellPrice)
                                calculateTtlProd(index, orderDetailItem.Qty, orderDetailItem.Count, orderDetailItem.SellPrice, e.target.value, orderDetailItem.RRP, orderDetailItem.IgnoreCrate)
                              }}
                              value={orderDetailItem.BuyPrice || ''}
                              ref={el => inputTypesRef[`${index}5`] = el}
                              onKeyDown={handleKeyEvent}
                            />
                            <span className="text-lite cps-10 fs-14">$</span>
                          </div>
                        </td>

                        <td>
                          <div className="position-relative input-icon">
                            <input
                              type="text"
                              className="form-control input-sm text-end ps-4 input-width-110"
                              value={orderDetailItem.Profit}
                              readOnly
                            />
                            <span className="text-lite cps-10 fs-14">%</span>
                          </div>
                        </td>
                        <td>
                          <div className="position-relative input-icon">
                            <input
                              type="text"
                              className="form-control input-sm text-end ps-4 input-width-110"
                              value={orderDetailItem.ExtSell || ''}
                              readOnly
                            />
                            <span className="text-lite cps-10 fs-14">$</span>
                          </div>
                        </td>
                        <td className="text-center">
                          <div className="position-relative input-icon">
                            <input
                              type="text"
                              className="form-control input-sm text-end ps-4 input-width-110"
                              value={orderDetailItem.RRP || ''}
                              onChange={(e) => handleInputChange(index, 'RRP', e.target.value)}
                              onBlur={(e) => {
                                calculateTtlProd(index, orderDetailItem.Qty, orderDetailItem.Count, orderDetailItem.SellPrice, orderDetailItem.BuyPrice, e.target.value, orderDetailItem.IgnoreCrate)
                              }}
                              id={`${index}6`}
                              ref={el => inputTypesRef[`${index}6`] = el}
                              onKeyDown={handleKeyEvent}
                            />
                            <span className="text-lite cps-10 fs-14">$</span>
                          </div>
                        </td>
                        <td className="text-center">
                          <div className="position-relative input-icon">
                            <input
                              type="text"
                              className="form-control input-sm text-end ps-4 input-width-110"
                              value={orderDetailItem.RRP ? orderDetailItem.RetailPC : ''}
                              onChange={(e) => handleInputChange(index, 'RetailPC', e.target.value)}
                              id={`${index}7`}
                              ref={el => inputTypesRef[`${index}7`] = el}
                              onKeyDown={handleKeyEvent}
                            />
                          </div>
                        </td>

                      </tr>)
                    })}

                  </tbody>
                </table>

              </div>
              <div className="spacer-sm-5"></div>
              <div className="row d-flex justify-content-between pb-3">
                <div className="col-md-1 d-flex">
                  <label className="p-1">
                    Items:
                  </label>
                  <input
                    type="text"
                    className="form-control input-sm text-end ps-4 input-width-110"
                    value={orderDetails ? orderDetails.length : 0}
                    readOnly
                  />
                </div>
                <div className="col-md-3 d-flex gap-3">
                  <div className="position-relative input-icon">
                    <input
                      type="text"
                      placeholder="0."
                      className="form-control input-sm text-end ps-4 input-width-110"
                      value={calculateTotalTtlProd()}
                      readOnly
                    />
                    <span className="text-lite cps-10 fs-14">$</span>
                  </div>
                  <div className="position-relative input-icon">
                    <input
                      type="text"
                      className="form-control input-sm text-end ps-4 input-width-110"
                      value={calculateProfitPercentage()}
                      readOnly
                    />
                    <span className="text-lite cps-10 fs-14">%</span>
                  </div>
                  <div className="position-relative input-icon">
                    <input
                      type="text"
                      className="form-control input-sm text-end ps-4 input-width-110"
                      value={calculateRRPPercentage()}
                      readOnly
                    />
                    <span className="text-lite cps-10 fs-14">%</span>
                  </div>
                </div>

              </div>
              <div className="row">
                <div className="col d-flex flex-column justify-content-between align-items-end mt-4 mt-lg-0">

                  <div className="d-flex">
                    <button type="button"
                      onClick={handlePriceList}
                      disabled={orderDetails.length > 0 ? false : true}
                      className="btn btn-md btn-outline-secondary d-flex align-items-center px-4 fw-medium rounded-3 mx-1"
                    >
                      Price List
                    </button>
                    <button type="button"
                      onClick={() => {
                        setCratesModal(true);
                      }}
                      disabled={orderDetails.length > 0 ? false : true}
                      className="btn btn-md btn-outline-secondary d-flex align-items-center px-4 fw-medium rounded-3 mx-1"
                    >
                      Crates
                    </button>
                    <button
                      type="button"
                      disabled={orderDetails.length > 0 ? false : true}
                      onClick={() => {
                        setAddOrderModal(true);
                      }}
                      className="btn btn-md btn-outline-secondary d-flex align-items-center px-4 fw-medium rounded-3 mx-1"
                    >
                      Add Order
                    </button>
                    <button onClick={() => setPreviewModal(true)}
                      disabled={orderDetails.length > 0 ? false : true}
                      type="button"
                      className="btn btn-md btn-outline-secondary d-flex align-items-center px-4 fw-medium rounded-3 mx-1"
                    >
                      Preview
                    </button>
                    <button type="button"
                      disabled={orderDetails.length > 0 ? false : true}
                      className="btn btn-md btn-secondary text-white d-flex align-items-center px-4 fw-medium rounded-3 mx-2"
                      onClick={() => saveBulkOrder()}
                    >
                      Save
                    </button>
                    <button type="button"
                      onClick={() => { navigate("/veg-art") }}
                      className="btn btn-md btn-secondary text-white d-flex align-items-center px-4 fw-medium rounded-3"
                    >
                      Exit
                    </button>
                  </div>
                </div>
              </div>
              {/* <div className="row">
                <div className="col-sm-12 d-flex justify-content-end">
                  <nav
                    aria-label="Page navigation example"
                    className="d-flex align-items-center"
                  >
                    <p className="mb-0 mt-3 text-lite fs-14">
                      Link Count: <span className="text-dark fs-15">5</span>
                    </p>
                  </nav>
                </div>
              </div> */}
              {!message && <div className="text-center"><span className='text-danger'>Kindly Save the Data before Exit Otherwise Data will be lost</span></div>}
            </div>
          </div>
        </section>
      </main>
    </React.Fragment>
  );
}

export default FinaliseOrder;
